import React from 'react';
import {
  Box,
  Fab,
  Tooltip,
  useMediaQuery,
  useTheme,
  alpha,
} from '@mui/material';
import {
  Phone,
  WhatsApp,
} from '@mui/icons-material';
import { CONTACT_CALL, CONTACT_WHATSAPP, getWhatsAppUrl, getCallUrl } from '../../utils/contact';

// WhatsApp color
const whatsappColor = '#25D366';
const phoneColor = '#8a211d'; // primary burgundy

const FloatingButtons = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const whatsappMessage = 'Hi! I need information about medical admissions.';

  const handleCall = () => {
    window.location.href = getCallUrl();
  };

  const handleWhatsApp = () => {
    window.open(getWhatsAppUrl(whatsappMessage), '_blank', 'noopener,noreferrer');
  };

  const buttonSize = isMobile ? 50 : 56;
  const iconSize = isMobile ? 22 : 26;

  const fabStyle = {
    width: buttonSize,
    height: buttonSize,
    minHeight: buttonSize,
    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      transform: 'scale(1.1)',
      boxShadow: '0 6px 25px rgba(0,0,0,0.4)',
    },
  };

  const containerStyle = {
    position: 'fixed',
    bottom: isMobile ? 16 : 24,
    right: isMobile ? 16 : 24,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1.5,
  };

  return (
    <Box sx={containerStyle}>
        {/* Call Button */}
        <Tooltip
          title="Call us now"
          placement="left"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: phoneColor,
                color: 'white',
                fontWeight: 600,
                fontSize: '0.8rem',
                px: 1.5,
                py: 0.75,
                '& .MuiTooltip-arrow': {
                  color: phoneColor,
                },
              },
            },
          }}
        >
          <Fab
            aria-label="Call"
            onClick={handleCall}
            sx={{
              ...fabStyle,
              bgcolor: phoneColor,
              color: 'white',
              border: '3px solid',
              borderColor: alpha(theme.palette.secondary.main, 0.6),
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
              },
            }}
          >
            <Phone sx={{ fontSize: iconSize }} />
          </Fab>
        </Tooltip>

        {/* WhatsApp Button */}
        <Tooltip
          title="Chat on WhatsApp"
          placement="left"
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: whatsappColor,
                color: 'white',
                fontWeight: 600,
                fontSize: '0.8rem',
                px: 1.5,
                py: 0.75,
                '& .MuiTooltip-arrow': {
                  color: whatsappColor,
                },
              },
            },
          }}
        >
          <Fab
            aria-label="WhatsApp"
            onClick={handleWhatsApp}
            sx={{
              ...fabStyle,
              bgcolor: whatsappColor,
              color: 'white',
              animation: 'pulse 2s infinite',
              '@keyframes pulse': {
                '0%': {
                  boxShadow: '0 0 0 0 rgba(37, 211, 102, 0.6)',
                },
                '70%': {
                  boxShadow: '0 0 0 12px rgba(37, 211, 102, 0)',
                },
                '100%': {
                  boxShadow: '0 0 0 0 rgba(37, 211, 102, 0)',
                },
              },
              '&:hover': {
                bgcolor: '#1ebe5d',
              },
            }}
          >
            <WhatsApp sx={{ fontSize: iconSize }} />
          </Fab>
        </Tooltip>
      </Box>
  );
};

export default FloatingButtons;